import React, { useEffect, useState } from 'react';
import {
    Routes,
    Route,
    useLocation
} from "react-router-dom";
import Minibar from '../../../components/navbar/Minibar.js';
import HistoricalCentralOverallTrack from './HistoricalCentralOverallTrack.js';
import HistoricalCentralBusinessTrack from './HistoricalCentralBusinessTrack.js';
import HistoricalCentralMultiSitesTrack from './HistoricalCentralMultiSitesTrack.js';

function HistoricalCentralData(props) {
    const location = useLocation();
    const [submenu_root, setSubmenu_root] = useState('-');

    useEffect(() => {
        if (location.pathname.search("/historical/historicaldashboard/overall") > -1) {
            setSubmenu_root('Overall Track')
        }
        if (location.pathname.search("/historical/historicaldashboard/business") > -1) {
            setSubmenu_root('Business Track')
        }
        if (location.pathname.search("/historical/historicaldashboard/multisites") > -1) {
            setSubmenu_root('Multi Sites Track')
        }
    }, [location]);

    return (
        <section id="content" className="content">
            <Minibar
                main_root={"Historical Tracking"}
                submenu_root={"Historical Central"}
                submenu_root2={submenu_root}
                systemtime={props.data_systemdatetime}
            />
            <div className="content__boxed d-md-flex h-100">
                <div className="content__wrap order-2 flex-fill min-w-0">
                    <Routes>
                        <Route path="/overall"
                            element={
                                <HistoricalCentralOverallTrack
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                ></HistoricalCentralOverallTrack>} />
                        <Route path="/business"
                            element={
                                <HistoricalCentralBusinessTrack
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                ></HistoricalCentralBusinessTrack>} />
                        <Route path="/multisites"
                            element={
                                <HistoricalCentralMultiSitesTrack
                                    systemtime={props.data_systemdatetime}
                                    permitdata={props.permitdata}
                                ></HistoricalCentralMultiSitesTrack>} />
                    </Routes>
                </div>
            </div>
        </section>
    )
}
export default HistoricalCentralData